module.exports = __webpack_public_path__ + "eb6b6425d6760a8e60def76d35b4e8be.svg";